import React, { useEffect } from "react";
import Login from "../../components/login/login.js";
import useTitle from "../../hooks/useTitle.js";

export default function LoginPage({ setPageTitle }) {
  useTitle("Login");

  useEffect(() => {
    setPageTitle("Login");
  });

  return <Login />;
}
